import * as React from "react";
import { connect } from "react-redux";
import "./qnot.css";
import moment from "moment";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { DateRangePicker } from "react-dates";
import LookupValueSelectList from "../LookupValueSelectList/LookupValueSelectList";
import { LookupValueTypes } from "../LookupValueSelectList/lookupValueTypes";
import {
  IExportColumnMap,
  INotification,
  PagedResultsRequest
} from "../../common/sharedTypes";
import { GetURIByParts } from "../../services/Utils/StringUtils";
import Api from "../../services/Api";
import { ApiResponse } from "apisauce";
import PagedDatatable from "../PagedDataTable";
import { TableColumn } from "react-data-table-component/dist/DataTable/types";
import {
  IQueuedNotificationSearchPagedResponse,
  QueuedNotificationSearchItem,
  QueuedNotificationSearchPagedRequest
} from "./business-objects/common";
import {
  setLoadingSentNotifications,
  setPagedSentNotifications,
  setTotalSentNotifications
} from "./redux-objects/actions";
import LocalStorageUtils from "../WorkflowQueues/common/LocalStorageUtils";

const $ = require("jquery");

export interface ISentNotificationsPagedStateProps {
  notifications: QueuedNotificationSearchItem[];
  webServiceURL: string;
  totalNotifications: number;
  loadingNotifications: boolean;
}

export interface ISentNotificationsPagedActionProps {
  setPagedSentNotifications?: (
    notificaitons: QueuedNotificationSearchItem[]
  ) => void;
  setLoadingSentNotifications?: (value: boolean) => void;
  setTotalSentNotifications?: (value: number) => void;
}

interface ISentNotificationsPagedProps
  extends ISentNotificationsPagedStateProps,
    ISentNotificationsPagedActionProps {}

enum ServiceEndPoints {
  GetNotifications = "GetNotifications",
  GetNotificationsPaged = "GetNotificationsPaged"
}

class SentNotificationsPaged extends React.Component<
  ISentNotificationsPagedProps,
  any
> {
  private startDateVariable: string = "SentNotificationsStartDate";
  private endDateVariable: string = "SentNotificationsEndDate";
  private userOnlyVariable: string = "SentNotificationsUserOnly";
  private notificationTypeIdVariable: string =
    "SentNotificationsNotificationTypeId";
  private reportTypeIdVariable: string = "SentNotificationsReportTypeId";
  private statusIdVariable: string = "SentNotificationsStatusId";

  public constructor(props: ISentNotificationsPagedProps) {
    super(props);
    this.state = {
      userOnly:
        LocalStorageUtils.getLocalStorage(this.userOnlyVariable) != null
          ? LocalStorageUtils.getLocalStorageBool(this.userOnlyVariable)
          : true,
      startDate: moment(
        moment().startOf("month").format("DD/MM/YYYY"),
        "DD/MM/YYYY"
      ), // moment('1/2/2019', 'DD/MM/YYYY'),
      endDate: moment(
        moment().endOf("month").format("DD/MM/YYYY"),
        "DD/MM/YYYY"
      ), //moment('28/2/2019', 'DD/MM/YYYY'),
      notificationTypeId:
        LocalStorageUtils.getLocalStorage(this.notificationTypeIdVariable) ||
        "-1",
      reportTypeId:
        LocalStorageUtils.getLocalStorage(this.reportTypeIdVariable) || "-1",
      focusedInput: null,
      statusId: LocalStorageUtils.getLocalStorage(this.statusIdVariable) || "3",
      pagingCriteria: {
        itemsPerPage: 10,
        pageNumber: 1,
        searchCriteria: null,
        orderByField: "Id",
        orderDescending: false
      }
    };
  }
  private notificationServiceController: string = "Notification";
  componentDidMount() {
    this.populateNotifications();
  }

  handleUserCheck(userChecked) {
    LocalStorageUtils.setLocalStorageItem(this.userOnlyVariable, userChecked);
    this.setState({ userOnly: userChecked }, () => {
      this.populateNotifications();
    });
  }

  handleDatesChanged(startDate, endDate) {
    if (startDate && endDate) {
      LocalStorageUtils.setLocalStorageItem(this.startDateVariable, startDate);
      LocalStorageUtils.setLocalStorageItem(this.endDateVariable, endDate);
      this.setState({ startDate, endDate }, () => {
        this.populateNotifications();
      });
    }
  }

  handleNotificationTypeChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    LocalStorageUtils.setLocalStorageItem(
      this.notificationTypeIdVariable,
      value
    );
    this.setState({ notificationTypeId: value }, () => {
      this.populateNotifications();
    });
  }

  handleReportTypeChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    LocalStorageUtils.setLocalStorageItem(this.reportTypeIdVariable, value);
    this.setState({ reportTypeId: value }, () => {
      this.populateNotifications();
    });
  }

  handleStatusTypeChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    LocalStorageUtils.setLocalStorageItem(this.statusIdVariable, value);
    this.setState({ statusId: value }, () => {
      this.populateNotifications();
    });
  }

  populateNotifications = async () => {
    this.props.setLoadingSentNotifications(true);
    try {
      const uri = GetURIByParts(
        this.props.webServiceURL,
        this.notificationServiceController,
        ServiceEndPoints.GetNotificationsPaged
      );
      const persistentStartDate = LocalStorageUtils.getLocalStorageDate(
        this.startDateVariable
      );
      const persistentEndDate = LocalStorageUtils.getLocalStorageDate(
        this.endDateVariable
      );

      const persistentUserOnly = LocalStorageUtils.getLocalStorageBool(
        this.userOnlyVariable
      );
      const persistentNotificationTypeId = LocalStorageUtils.getLocalStorage(
        this.notificationTypeIdVariable
      );

      const persistentReportTypeId = LocalStorageUtils.getLocalStorage(
        this.reportTypeIdVariable
      );

      const persistentStatusId = LocalStorageUtils.getLocalStorage(
        this.statusIdVariable
      );

      const request: QueuedNotificationSearchPagedRequest = {
        ...this.state.pagingCriteria,
        userOnly: persistentUserOnly || this.state.userOnly,
        startDate: persistentStartDate
          ? persistentStartDate.toDate()
          : this.state.startDate.toDate(),
        endDate: persistentEndDate
          ? persistentEndDate.toDate()
          : this.state.endDate.toDate(),
        notificationTypeId: persistentNotificationTypeId
          ? Number(persistentNotificationTypeId)
          : Number(this.state.notificationTypeId),
        reportTypeId: persistentReportTypeId
          ? Number(persistentReportTypeId)
          : Number(this.state.reportTypeId),
        statusId: persistentStatusId
          ? Number(persistentStatusId)
          : Number(this.state.statusId),
        reportsOnly: true
      };

      const response: ApiResponse<IQueuedNotificationSearchPagedResponse> =
        await Api.post(uri, request);
      if (response.ok) {
        this.props.setPagedSentNotifications(response.data.notifications);
        this.props.setTotalSentNotifications(response.data.totalResults);
      }
    } catch (ex) {
      console.log(ex);
    } finally {
      this.props.setLoadingSentNotifications(false);
    }
  };

  getExportData = async () => {
    const uri = GetURIByParts(
      this.props.webServiceURL,
      this.notificationServiceController,
      ServiceEndPoints.GetNotificationsPaged
    );
    const persistentStartDate = LocalStorageUtils.getLocalStorageDate(
      this.startDateVariable
    );
    const persistentEndDate = LocalStorageUtils.getLocalStorageDate(
      this.endDateVariable
    );

    const persistentUserOnly = LocalStorageUtils.getLocalStorageBool(
      this.userOnlyVariable
    );
    const persistentNotificationTypeId = LocalStorageUtils.getLocalStorage(
      this.notificationTypeIdVariable
    );

    const persistentReportTypeId = LocalStorageUtils.getLocalStorage(
      this.reportTypeIdVariable
    );

    const persistentStatusId = LocalStorageUtils.getLocalStorage(
      this.statusIdVariable
    );
    const request: QueuedNotificationSearchPagedRequest = {
      ...this.state.pagingCriteria,
      itemsPerPage: this.props.totalNotifications,
      pageNumber: 1,
      userOnly: persistentUserOnly || this.state.userOnly,
      startDate: persistentStartDate
        ? persistentStartDate.toDate()
        : this.state.startDate.toDate(),
      endDate: persistentEndDate
        ? persistentEndDate.toDate()
        : this.state.endDate.toDate(),
      notificationTypeId: persistentNotificationTypeId
        ? Number(persistentNotificationTypeId)
        : Number(this.state.notificationTypeId),
      reportTypeId: persistentReportTypeId
        ? Number(persistentReportTypeId)
        : Number(this.state.reportTypeId),
      statusId: persistentStatusId
        ? Number(persistentStatusId)
        : Number(this.state.statusId),
      reportsOnly: true
    };

    const response: ApiResponse<IQueuedNotificationSearchPagedResponse> =
      await Api.post(uri, request);

    if (response.ok) {
      return response.data?.notifications || [];
    }
    return [];
  };

  handlePagingCriteriaChange = (pagingCriteria: PagedResultsRequest) => {
    this.setState({ pagingCriteria: pagingCriteria as any }, () => {
      this.populateNotifications();
    });
  };

  handleClearDateSelection = (): void => {
    LocalStorageUtils.removeLocalStorageItem(this.startDateVariable);
    LocalStorageUtils.removeLocalStorageItem(this.endDateVariable);
    this.setState(
      {
        startDate: moment(
          moment().startOf("month").format("DD/MM/YYYY"),
          "DD/MM/YYYY"
        ), // moment('1/2/2019', 'DD/MM/YYYY'),
        endDate: moment(
          moment().endOf("month").format("DD/MM/YYYY"),
          "DD/MM/YYYY"
        )
      },
      () => {
        this.populateNotifications();
      }
    );
  };

  columns: TableColumn<QueuedNotificationSearchItem>[] = [
    {
      name: "DATE SENT/PRINTED",
      sortable: true,
      sortField: "SentDate",
      wrap: true,
      selector: (row: QueuedNotificationSearchItem) =>
        row?.sentDate ? moment(row.sentDate).format("MMM D, yyyy h:mmA") : ""
    },
    {
      name: "LETTER METHOD",
      sortField: "NotificationTypeName",
      wrap: true,
      selector: (row: QueuedNotificationSearchItem) =>
        row?.notificationTypeName || "",
      sortable: true
    },
    {
      name: "SENT TO",
      sortField: "SentTo",
      wrap: true,
      selector: (row: QueuedNotificationSearchItem) => row?.sentTo || "",
      sortable: true
    },
    {
      name: "SENT BY",
      sortField: "CreatedByUserName",
      wrap: true,
      selector: (row: QueuedNotificationSearchItem) =>
        row?.createdByUserName || "",
      sortable: true
    },
    {
      name: "SUBJECT",
      sortField: "Subject",
      wrap: true,
      selector: (row: QueuedNotificationSearchItem) => row?.subject || "",
      sortable: true
    },
    {
      name: "LETTER TYPE",
      sortField: "NotificationTemplatename",
      wrap: true,
      selector: (row: QueuedNotificationSearchItem) =>
        row?.notificationTemplateName || "",
      sortable: true
    }
  ];

  exportColumnMaps: IExportColumnMap[] = [
    { columnName: "ID", propertyName: "id" },
    {
      columnName: "DATE SENT/PRINTED",
      propertyName: "sentDate",
      convertMethod: (val) => moment(val).format("MM/DD/YYYY hh:mma")
    },
    { columnName: "LETTER METHOD", propertyName: "notificationTypeName" },
    { columnName: "SEND TO", propertyName: "sentTo" },
    { columnName: "SENT BY", propertyName: "createdByUserName" },
    { columnName: "SUBJECT", propertyName: "subject" },
    { columnName: "LETTER TYPE", propertyName: "notificationTemplateName" }
  ];

  public render() {
    return (
      <div className="app">
        <h3>Sent Letters</h3>
        <hr />
        <Form>
          <Form.Group controlId="formBasicChecbox">
            <Form.Check
              id="chkSentOnlyICreated"
              type="checkbox"
              label=" Show only Letters I created"
              checked={
                LocalStorageUtils.getLocalStorageBool(this.userOnlyVariable) ||
                this.state.userOnly
              }
              onChange={(e) => this.handleUserCheck(e.target.checked)}
            />
          </Form.Group>
          <Form.Row>
            <Form.Group as={Col} controlId="sentNotificationsStartDate">
              <Form.Label>Created Date</Form.Label>
              <br />
              <DateRangePicker
                startDate={
                  LocalStorageUtils.getLocalStorageDate(
                    this.startDateVariable
                  ) || this.state.startDate
                } // momentPropTypes.momentObj or null,
                startDateId="sentNotificationsStartDate" // PropTypes.string.isRequired,
                endDate={
                  LocalStorageUtils.getLocalStorageDate(this.endDateVariable) ||
                  this.state.endDate
                } // momentPropTypes.momentObj or null,
                endDateId="sentNotificationsEndDate" // PropTypes.string.isRequired,
                onDatesChange={({ startDate, endDate }) =>
                  this.handleDatesChanged(startDate, endDate)
                } // PropTypes.func.isRequired,
                focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                onFocusChange={(focusedInput) =>
                  this.setState({ focusedInput })
                } // PropTypes.func.isRequired,
                isOutsideRange={() => false}
                small={true}
                block={false}
                minimumNights={0}
              />
              {(LocalStorageUtils.getLocalStorageDate(this.startDateVariable) ||
                LocalStorageUtils.getLocalStorageDate(
                  this.endDateVariable
                )) && (
                <button
                  className="btn btn-outline-danger btn-sm"
                  style={{ fontSize: "14px", marginLeft: "5px" }}
                  title="Clear Date Filter"
                  onClick={this.handleClearDateSelection}
                >
                  <i className="fa fa-calendar-xmark" />
                </button>
              )}
            </Form.Group>

            <Form.Group as={Col} controlId="exampleForm.ControlSelect1">
              <Form.Label>Letter Type</Form.Label>
              <LookupValueSelectList
                onChange={(e) => this.handleNotificationTypeChange(e)}
                value={
                  LocalStorageUtils.getLocalStorage(
                    this.notificationTypeIdVariable
                  ) || this.state.notificationTypeId
                }
                type={LookupValueTypes.NOTIFICATION_TYPES}
                includeAll={true}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="exampleForm.ControlSelect2">
              <Form.Label>Report Type</Form.Label>
              <LookupValueSelectList
                onChange={(e) => this.handleReportTypeChange(e)}
                value={
                  LocalStorageUtils.getLocalStorage(
                    this.reportTypeIdVariable
                  ) || this.state.reportTypeId
                }
                type={LookupValueTypes.REPORT_TYPES}
                includeAll={true}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="exampleForm.ControlSelect3">
              <Form.Label>Status</Form.Label>
              <LookupValueSelectList
                onChange={(e) => this.handleStatusTypeChange(e)}
                value={
                  LocalStorageUtils.getLocalStorage(this.statusIdVariable) ||
                  this.state.statusId
                }
                type={LookupValueTypes.NOTIFICATION_STATUS_TYPES}
                exclude={["queued"]}
                includeAll={false}
              />
            </Form.Group>
          </Form.Row>
        </Form>
        <PagedDatatable
          columns={this.columns}
          data={this.props.notifications || []}
          loadingData={this.props.loadingNotifications}
          totalDataItems={this.props.totalNotifications}
          exportTitle="Sent Letters"
          exportFileName="SentLetters"
          exportColumnMaps={this.exportColumnMaps}
          pagingCriteria={this.state.pagingCriteria}
          updatePagedResults={this.handlePagingCriteriaChange}
          getExportData={this.getExportData}
        ></PagedDatatable>
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    notifications: state.qnotification.pagedSentNotifications,
    webServiceURL: state.Application.backendURL,
    loadingNotifications: state.qnotification.loadingSentNotifications,
    totalNotifications: state.qnotification.totalSentNotifications
  };
}

const mapDispatchToProps = {
  setPagedSentNotifications,
  setLoadingSentNotifications,
  setTotalSentNotifications
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SentNotificationsPaged);
